import React from "react"
import { SvgIcon, SvgIconProps } from "@mui/material"
const fullScreenSvg = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.5 4V9.5H20V10.8571H13.1429V4H14.5ZM9.5 20V14.5H4V13.1429H10.8571V20H9.5Z" fill="currentColor"/>
    </svg>
)
const FullScreenReverseIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {fullScreenSvg}
    </SvgIcon>
)
export default FullScreenReverseIcon